module.exports = __webpack_public_path__ + "448c34a56d699c29117adc64c43affeb.woff2";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/glyphicons-halflings-regular.woff2
// module id = 338
// module chunks = 0